export default __webpack_public_path__ + "static/media/party.ec9f5437.jpg";